import { useEffect, useState } from 'react';

import { strings } from '../strings';
import type { NewsItem } from '../types/news';
import { fetchNews } from '../utils/news';

export const useNews = () => {
  const [news, setNews] = useState<NewsItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    fetchNews()
      .then(fetchedNews => {
        if (!isMounted) {
          return;
        }

        setNews(fetchedNews);
        setIsLoading(false);
      })
      .catch(caughtError => {
        if (!isMounted) {
          return;
        }

        console.error('Failed to fetch news', caughtError);
        setError(strings.unableToLoadNews);
        setIsLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return { news, isLoading, error };
};
